const ONE_YEAR = 60 * 60 * 24 * 365;
const TWENTY_YEARS = ONE_YEAR * 20;
const SESSION_MAX_AGE = 60 * 60 * 2;
const SESSION_COOKIE = 'catch-session';
const USER_COOKIE = 'catch-user';
const THEME_COOKIE = 'catch-theme';
const DEFAULT_THEME = 'light';

function setCookie(name, value, { maxAge = ONE_YEAR } = {}) {
  if (typeof document === 'undefined') return;

  let cookie = `${name}=${encodeURIComponent(value)}; path=/; SameSite=Lax`;

  if (Number.isFinite(maxAge) && maxAge > 0) {
    cookie += `; max-age=${Math.floor(maxAge)}`;
  }

  if (typeof location !== 'undefined' && location.protocol === 'https:') {
    cookie += '; Secure';
  }

  document.cookie = cookie;
}

function deleteCookie(name) {
  if (typeof document === 'undefined') return;
  let cookie = `${name}=; path=/; max-age=0; SameSite=Lax`;
  if (typeof location !== 'undefined' && location.protocol === 'https:') {
    cookie += '; Secure';
  }
  document.cookie = cookie;
}

function readCookie(name) {
  if (typeof document === 'undefined') return null;
  const match = document.cookie
    .split(';')
    .map((chunk) => chunk.trim())
    .find((chunk) => chunk.startsWith(`${name}=`));
  if (!match) return null;
  return decodeURIComponent(match.slice(name.length + 1));
}

function createId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}

function ensureSessionCookie({ persistent }) {
  const value = readCookie(SESSION_COOKIE) || createId();
  setCookie(SESSION_COOKIE, value, { maxAge: persistent ? SESSION_MAX_AGE : null });
  return value;
}

function ensureUserCookie({ persistent }) {
  const value = readCookie(USER_COOKIE) || createId();
  setCookie(USER_COOKIE, value, { maxAge: persistent ? TWENTY_YEARS : null });
  return value;
}

function ensureThemeCookie() {
  const theme = readCookie(THEME_COOKIE);
  if (theme === DEFAULT_THEME) {
    return theme;
  }

  setCookie(THEME_COOKIE, DEFAULT_THEME, { maxAge: ONE_YEAR });
  return DEFAULT_THEME;
}

function applyTrackingConsent(analyticsAllowed) {
  const persistent = Boolean(analyticsAllowed);
  const userValue = ensureUserCookie({ persistent });
  const sessionValue = ensureSessionCookie({ persistent });
  return { userId: userValue, sessionId: sessionValue, persistent };
}

function getSessionId() {
  return readCookie(SESSION_COOKIE);
}

function getUserId() {
  return readCookie(USER_COOKIE);
}

const cookieApi = {
  init: ({ analyticsAllowed = false } = {}) => {
    const theme = ensureThemeCookie();
    const tracking = applyTrackingConsent(analyticsAllowed);
    return { ...tracking, theme };
  },
  applyTrackingConsent,
  read: readCookie,
  write: setCookie,
  delete: deleteCookie,
  getSessionId,
  getUserId,
};

export default cookieApi;
